<li class="toggle-toolbar-menu toggle-smiley dropup">
    <a class="toggle-smiley far fa-smile" title="{{{o.tooltip_insert_smiley}}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
    <div class="emoji-picker dropdown-menu toolbar-menu"></div>
</li>
